import axios from 'axios';

class CebeoService {
  constructor() {
    window.Cypress
      ? this.basePath = ''
      : this.basePath = process.env.VUE_APP_SERVICEURL;
  }

  doApiCall(type, endpoint, action, data = { empty: true }) {
    return new Promise(
      (resolve, reject) => {
        axios[type](this.basePath + endpoint, data)
          .then((response) => {
            if (process.env.NODE_ENV === 'development') {
              console.log('Ocu Service Response', action, endpoint, data, response);
            }
            resolve(response.data);
          })
          .catch((error) => {
            console.log('Ocu Service Error', action, endpoint, data, error);
            reject(error);
          });
      }
    );
  }

  doBlobCall(type, endpoint, action, data = {}) {
    return new Promise(
      (resolve, reject) => {
        axios({
          method: type,
          url: this.basePath + endpoint,
          data,
          responseType: 'blob'
        })
          .then((response) => {
            if (process.env.NODE_ENV === 'development') {
              console.log('Ocu Service Response', action, endpoint, response);
            }
            resolve(response);
          })
          .catch((error) => {
            console.log('Ocu Service Error', action, endpoint, error);
            reject(error);
          });
      }
    );
  }
}

export default new CebeoService();
